
import Vue from "vue";
import AppServicePackInfo from "@/components/account/ServicePackInfo.vue";
import AppServicePackAdvantages from "@/components/account/ServicePackAdvantages.vue";
import AppBillingAddressEdit from "@/components/account/BillingAddressEditCard.vue";
import AppBillingAddressCard from "@/components/account/BillingAddressCard.vue";
import { BillingAddress } from "@/models/billing-address";
import { CompanyService } from "@/services/company-service";

export default Vue.extend({
	data(){
		return {
			hasBillingAddress: false,
			editBillingAddress: false,
			ready: false,
			billingAddress: new BillingAddress()
		};
	},
	computed: {
		isEditingBillingAddress():boolean {
			return !this.hasBillingAddress || this.editBillingAddress;
		}
	},
	methods: {
		async fetchBillingAddress(){
			this.hasBillingAddress = false;
			this.billingAddress = await CompanyService.getBillingAddress();
			this.hasBillingAddress = true;
		},
		onNewBillingAddress(address:BillingAddress){
			this.billingAddress = address;
			this.editBillingAddress = false;
		}
	},
	async created(){
		try{
			await this.fetchBillingAddress();
		}catch(err){

		}
		this.ready = true;
	},
	components: {
		AppServicePackInfo,
		AppServicePackAdvantages,
		AppBillingAddressEdit,
		AppBillingAddressCard
	}
});
